export const DOD = "dod";
export const WOW = "wow";
export const MOM = "mom";
export const QOQ = "qoq";

export const TRACKER_SUMMARY = "Tracker Summary";
export const PARTNER_LEVEL = "Partner Level";
export const TRACKER_LEVEL = "Tracker";
